enum Theme {
  LIGHT = 'LIGHT',
  DARK = 'DARK',
}

export default Theme;
